import { createAction, props } from '@ngrx/store';
import { adminProfile } from './layout.model';

export const changelayoutTheme = createAction('[Layout] Set Layout', props<{ layout: string }>());
export const changeTheme = createAction('[Layout] Set theme', props<{ theme: string }>());
export const changeMode = createAction('[Layout] Set Mode', props<{ mode: string }>());
export const changewidthLayout = createAction('[Layout] Set width', props<{ width: string }>());
export const changeposition = createAction('[Layout] Set position', props<{ position: string }>());
export const changetopbar = createAction('[Layout] Set topbar', props<{ topbar: string }>());
export const changesize = createAction('[Layout] Set size', props<{ size: string }>());
export const changesidebarView = createAction('[Layout] Set sidebarView', props<{ sidebarView: string }>());
export const changesidebarcolor = createAction('[Layout] Set sidebar', props<{ sidebar: string }>());
export const changesidebarImage = createAction('[Layout] Set sidebarImage', props<{ sidebarImage: string }>());
export const changepreLoader = createAction('[Layout] Set preLoader', props<{ preLoader: string }>());

// fetch admin profile data
export const fetchAdminProfileData = createAction('[Data] Fetch Admin Profile Data');
export const fetchAdminProfileSuccess = createAction('[Data] Fetch Admin Profile Data Success', props<{ adminProfiledata: adminProfile }>());
export const fetchAdminProfileFailure = createAction('[Data] Fetch Admin Profile Data Failure', props<{ error: string }>());

//update admin profile image
export const updateAdminProfileImage = createAction('[Data] Update Admin Profile Image', props<{ payload: any }>());
export const updateAdminProfileImageSuccess = createAction('[Data] Update Admin Profile Image Success', props<{ payload: any }>());
export const updateAdminProfileImageFailure = createAction('[Data] Update Admin Profile Image Failure', props<{ error: any }>());

//update admin profile
export const updateAdminProfile = createAction('[Data] Update Admin Profile ', props<{ payload: any }>());
export const updateAdminProfileSuccess = createAction('[Data] Update Admin Profile  Success', props<{ payload: any }>());
export const updateAdminProfileFailure = createAction('[Data] Update Admin Profile  Failure', props<{ error: any }>());

//Change Password
export const changePassword = createAction('[Data] Change Password ', props<{ payload: any }>());
export const changePasswordSuccess = createAction('[Data] Change Password  Success', props<{ payload: any }>());
export const changePasswordFailure = createAction('[Data] Change Password  Failure', props<{ error: any }>());
